import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  clubObject: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/club/vuex/index.js